import { createApp } from "vue";
import App from "./app/App.vue";
import Routes from "./app/routes";
import Toast from "vue-toastification";
import { toastOptions } from "./app/toast/ToastOptions";
import "./app/toast/toast.scss";
import "mapbox-gl/dist/mapbox-gl.css";
import { appStore } from "app/store/AppStore";
import LoadScript from "vue-plugin-load-script";
console.log("%cInfiniteX", `background:#0A0A14;
    color: #edf2f4;
    padding-inline: 4.2em;
    padding-block: 1em;
    font-size: 1rem;
    border-radius: 0.25em;`);
console.info("---- Made by Avon FitzGerald ----");
createApp(App)
    .use(Routes)
    .use(appStore)
    .use(LoadScript)
    .use(Toast, toastOptions)
    .mount("#app");
